export default __webpack_public_path__ + "static/media/aboutImg.6109aedc.png";